import type { FilterKey, FilterOptions, Filters, Option } from "../lib/eventsPage";

function Pick({
  label,
  k,
  options,
  filters,
  onChange,
}: {
  label: string;
  k: FilterKey;
  options: Option[];
  filters: Filters;
  onChange: (k: FilterKey, v: string) => void;
}) {
  return (
    <label className="grid gap-1 text-xs text-muted">
      {label}
      <select
        value={filters[k]}
        onChange={(e) => onChange(k, e.target.value)}
        className="min-w-0 rounded-lg border border-line bg-surface px-2.5 py-2 text-[15px] text-neutral-100"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}

/**
 * Every available filter, in display order. The option lists come from the
 * server, already narrowed by the selection above them, so this renders
 * choices and reports picks and nothing else.
 */
export function FilterPanel({
  options,
  filters,
  onChange,
}: {
  options: FilterOptions;
  filters: Filters;
  onChange: (k: FilterKey, v: string) => void;
}) {
  const p = { filters, onChange };
  return (
    <div className="grid gap-3">
      <Pick label="Sport" k="sport" options={options.sport} {...p} />
      <Pick label="League" k="league" options={options.league} {...p} />
      <Pick label="Team" k="team" options={options.team} {...p} />
      {filters.team !== "All" && (
        <div role="group" aria-label="Home or away" className="flex gap-1">
          {["All", "Home", "Away"].map((s) => (
            <button
              key={s}
              type="button"
              aria-pressed={filters.side === s}
              onClick={() => onChange("side", s)}
              className={`min-h-9 flex-1 rounded-md border text-[13px] ${
                filters.side === s ? "border-faint bg-raised text-neutral-100" : "border-line text-muted"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      )}
      <Pick label="Venue" k="venue" options={options.venue} {...p} />
      <Pick label="Game type" k="game_type" options={options.game_type} {...p} />
      {options.special.length > 1 && <Pick label="Special event" k="special" options={options.special} {...p} />}
      {options.attendee.length > 1 && <Pick label="Attended with" k="with" options={options.attendee} {...p} />}
      <Pick label="Year" k="year" options={options.year} {...p} />
    </div>
  );
}
